import { render, staticRenderFns } from "./wuXingXq.vue?vue&type=template&id=7b1cdc79"
import script from "./wuXingXq.vue?vue&type=script&lang=js"
export * from "./wuXingXq.vue?vue&type=script&lang=js"
import style0 from "./wuXingXq.vue?vue&type=style&index=0&id=7b1cdc79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports